import {useRegisterErrors} from '../../../hooks/use-register-errors'
import type {RegisteredRuleErrorComponent} from '../../../types/rules-types'
import {RulesetFormErrorFlash} from '../../RulesetFormErrorFlash'

export const CopilotCodeReviewAnalysisToolsError = ({
  errors,
  errorId,
  errorRef,
  fields,
}: RegisteredRuleErrorComponent) => {
  const parsedErrors = useRegisterErrors({errors, fields})
  let message: string | undefined = undefined

  if (parsedErrors.missing && parsedErrors.missing.length > 0) {
    message =
      parsedErrors.missing[0]?.sub_errors?.[0]?.message ||
      'Please select at least one static analysis tool for Copilot code review'
  } else if (parsedErrors.unregistered && parsedErrors.unregistered.length > 0) {
    message = parsedErrors.unregistered[0]?.message || 'An error occurred'
  }
  return message ? (
    <RulesetFormErrorFlash errorId={errorId} errorRef={errorRef}>
      {message}
    </RulesetFormErrorFlash>
  ) : null
}
